import InvoiceManagementOverview from "./InvoiceManagementOverview";
import InvoiceManagementProvider from "./InvoiceManagementProvider";

function InvoiceManagement(props) {
    return (
        <InvoiceManagementProvider>
            <InvoiceManagementOverview />
        </InvoiceManagementProvider>
    );
}

export default InvoiceManagement;
